import type { MealDishFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: MealDishFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.title,
    imageURL: item.picture?.source,
    blurhash: item.picture?.blurhash,
  } as IMultiSelectItem;
};

const toOption = (item: MealDishFragment): IOption => {
  return {
    value: item.id,
    title: item.title,
  } as IOption;
};

export default {
  toMultiSelectItem,
  toOption,
};
